import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, errorMessage, formatDate } from "@/lib/api";
import { Notice } from "@/components/form/FormFeedback";
import { Loading } from "@/components/layout/RequireAuth";
import { usePageTitle } from "@/components/layout/AppLayout";
import { ScoreSummary, AnswersByStep } from "@/components/assessment/ScoreSummary";

export default function SubmissionDetail() {
    usePageTitle("Risultato assessment");
    const { id } = useParams();
    const [s, setS] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        api.get(`/companies/me/assessments/${id}`).then(({ data }) => setS(data)).catch((e) => setError(errorMessage(e)));
    }, [id]);

    return (
        <div className="mx-auto max-w-4xl px-4 sm:px-6 py-10">
            <Link to="/profilo?tab=assessment" className="inline-flex items-center gap-1" data-testid="submission-back-link">
                <ArrowLeft aria-hidden="true" size={16} /> Torna all'Assessment AI
            </Link>
            {error && <div className="mt-6"><Notice kind="error" role="alert">{error}</Notice></div>}
            {!s && !error && <Loading />}
            {s && (
                <>
                    <h1 className="mt-6 text-3xl sm:text-4xl font-extrabold" data-testid="submission-title">Assessment del {formatDate(s.submitted_at)}</h1>
                    <section className="edi-card p-5 sm:p-6 mt-6"><ScoreSummary submission={s} /></section>
                    <section className="edi-card p-5 sm:p-6 mt-6" aria-labelledby="sub-answers-title">
                        <h2 id="sub-answers-title" className="text-xl font-bold">Risposte</h2>
                        <div className="mt-4"><AnswersByStep view={s.answers_view} /></div>
                    </section>
                </>
            )}
        </div>
    );
}
